import { render, staticRenderFns } from "./notification-phone-note-list-receive.vue?vue&type=template&id=6c71bcb6&"
import script from "./notification-phone-note-list-receive.vue?vue&type=script&lang=js&"
export * from "./notification-phone-note-list-receive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports